import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

// Grid 1: Trust Visualization (6 images)
const trustGrid = [
  {
    src: "/imgs/Grid%201/alexander-shatov-niUkImZcSP8-unsplash.jpg",
    alt: {
      en: "AI audio file analysis",
      ar: "تحليل الملفات الصوتية بالذكاء الاصطناعي"
    }
  },
  {
    src: "/imgs/Grid%201/blue-1866471_1920.jpg", 
    alt: {
      en: "High accuracy text processing",
      ar: "معالجة النصوص بدقة عالية"
    }
  },
  {
    src: "/imgs/Grid%201/circles-6998838_1920.jpg",
    alt: {
      en: "Advanced machine learning technology", 
      ar: "تقنيات التعلم الآلي المتقدمة"
    }
  },
  {
    src: "/imgs/Grid%201/computer-4146579_1920.jpg",
    alt: {
      en: "Professional transcription team",
      ar: "فريق عمل محترف للنسخ"
    }
  },
  {
    src: "/imgs/Grid%201/student-849825_1920.jpg",
    alt: {
      en: "Advanced AI solutions",
      ar: "حلول الذكاء الاصطناعي المتطورة"
    }
  },
  {
    src: "/imgs/Grid%201/blue-1866471_1920.jpg",
    alt: {
      en: "Global audio services", 
      ar: "خدمات صوتية عالمية"
    }
  }
];

// Grid 2: Feature Demonstration (6 images)
const demoGrid = [
  {
    src: "/imgs/Grid%202/code-1839406_1280.jpg",
    alt: {
      en: "Advanced audio waveform analysis",
      ar: "تحليل الموجات الصوتية المتقدم"
    }
  },
  {
    src: "/imgs/Grid%202/computer-1185626_1920.jpg",
    alt: {
      en: "Digital audio processing workflow",
      ar: "معالجة الصوت الرقمي"
    }
  },
  {
    src: "/imgs/Grid%202/kimberly-farmer-lUaaKCUANVI-unsplash.jpg",
    alt: {
      en: "Professional content recording",
      ar: "تقنيات تسجيل المحتوى"
    }
  },
  {
    src: "/imgs/Grid%202/luke-jones-tBvF46kmwBw-unsplash.jpg",
    alt: {
      en: "Mobile audio processing",
      ar: "معالجة الصوت المحمولة"
    }
  },
  {
    src: "/imgs/Grid%202/music-6621800_1920.jpg",
    alt: {
      en: "Smart note-taking system",
      ar: "نظام تدوين الملاحظات الذكي"
    }
  },
  {
    src: "/imgs/Grid%202/richard-horvath-WOA3QKFjlo8-unsplash.jpg",
    alt: {
      en: "Educational audio transcription",
      ar: "نسخ الصوت التعليمي"
    }
  }
];

// Grid 3: Technology Solutions (6 images)
const techGrid = [
  {
    src: "/imgs/Grid%201/circles-6998838_1920.jpg",
    alt: {
      en: "Business audio transcription solutions",
      ar: "حلول نسخ الصوت للأعمال"
    }
  },
  {
    src: "/imgs/Grid%203/job-5382501_1920.jpg",
    alt: {
      en: "AI-powered transcription technology",
      ar: "تقنية النسخ المدعومة بالذكاء الاصطناعي"
    }
  },
  {
    src: "/imgs/Grid%203/mobile-phone-1419275_1920.jpg",
    alt: {
      en: "Global connectivity for audio processing",
      ar: "اتصال عالمي لمعالجة الصوت"
    }
  },
  {
    src: "/imgs/Grid%203/nasa-Q1p7bh3SHj8-unsplash.jpg",
    alt: {
      en: "Advanced audio technology infrastructure",
      ar: "بنية تحتية متقدمة لتقنية الصوت"
    }
  },
  {
    src: "/imgs/Grid%203/notes-514998_1920.jpg",
    alt: {
      en: "Audio data analytics and insights",
      ar: "تحليلات ورؤى البيانات الصوتية"
    }
  },
  {
    src: "/imgs/Grid%203/sticky-notes-7705489_1920.jpg",
    alt: {
      en: "Secure audio processing and privacy",
      ar: "معالجة صوت آمنة وخصوصية"
    }
  }
];

// Grid 4: Professional Services (6 images)  
const serviceGrid = [
  {
    src: "/imgs/Grid%203/Keys.jpg",
    alt: {
      en: "Professional meeting transcription",
      ar: "نسخ الاجتماعات المهنية"
    }
  },
  {
    src: "/imgs/Grid%204/jj-ying-8bghKxNU1j0-unsplash.jpg",
    alt: {
      en: "Educational content transcription",
      ar: "نسخ المحتوى التعليمي"
    }
  },
  {
    src: "/imgs/Grid%204/john-2FPjlAyMQTA-unsplash.jpg",
    alt: {
      en: "High-quality audio recording setup",
      ar: "إعداد تسجيل صوتي عالي الجودة"
    }
  },
  {
    src: "/imgs/Grid%204/milad-fakurian-PGdW_bHDbpI-unsplash.jpg",
    alt: {
      en: "Academic research transcription services",
      ar: "خدمات نسخ البحث الأكاديمي"
    }
  },
  {
    src: "/imgs/Grid%204/plasma.jpg",
    alt: {
      en: "Professional document processing",
      ar: "معالجة المستندات المهنية"
    }
  },
  {
    src: "/imgs/Grid%204/tom-krach-yWyBU5v3FLI-unsplash.jpg",
    alt: {
      en: "Collaborative audio transcription workflow",
      ar: "سير عمل تعاوني لنسخ الصوت"
    }
  }
];

const ImageGrid = ({ gridType = 1, className = "" }) => {
  const { language } = useLanguage();
  
  const getImages = () => {
    switch (gridType) {
      case 1: return trustGrid;
      case 2: return demoGrid;
      case 3: return techGrid;
      case 4: return serviceGrid;
      default: return trustGrid;
    }
  };

  const images = getImages();

  return (
    <div className={`image-grid ${className}`}>
      <div className="row g-4">
        {images.map((image, index) => (
          <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={index * 100}>
            <div className="card border-0 shadow-sm h-100" style={{ background: 'transparent', overflow: 'hidden' }}>
              <img 
                src={image.src}
                alt={image.alt[language]}
                className="card-img-top" 
                style={{ height: '250px', objectFit: 'cover', borderRadius: '8px' }}
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGrid;